// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from './client';
import type { ExposedPostCommentData, ExposedPostCommentResponses, ExposedPostCommentErrors, ExposedGetCommentsData, ExposedGetCommentsResponses, ExposedGetCommentsErrors, ExposedGetOriginCommentsCountData, ExposedGetOriginCommentsCountResponses, ExposedGetOriginCommentsCountErrors } from './types.gen';
import { zExposedPostCommentData, zExposedGetCommentsData, zExposedGetCommentsResponse, zExposedGetOriginCommentsCountData, zExposedGetOriginCommentsCountResponse } from './zod.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const exposedPostComment = <ThrowOnError extends boolean = false>(options: Options<ExposedPostCommentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ExposedPostCommentResponses, ExposedPostCommentErrors, ThrowOnError>({
        requestValidator: async (data) => {
            return await zExposedPostCommentData.parseAsync(data);
        },
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/comment',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const exposedGetComments = <ThrowOnError extends boolean = false>(options: Options<ExposedGetCommentsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ExposedGetCommentsResponses, ExposedGetCommentsErrors, ThrowOnError>({
        requestValidator: async (data) => {
            return await zExposedGetCommentsData.parseAsync(data);
        },
        responseValidator: async (data) => {
            return await zExposedGetCommentsResponse.parseAsync(data);
        },
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/comments',
        ...options
    });
};

export const exposedGetOriginCommentsCount = <ThrowOnError extends boolean = false>(options: Options<ExposedGetOriginCommentsCountData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ExposedGetOriginCommentsCountResponses, ExposedGetOriginCommentsCountErrors, ThrowOnError>({
        requestValidator: async (data) => {
            return await zExposedGetOriginCommentsCountData.parseAsync(data);
        },
        responseValidator: async (data) => {
            return await zExposedGetOriginCommentsCountResponse.parseAsync(data);
        },
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/origin/{originId}/comments/count',
        ...options
    });
};